var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "26px",
        height: "26px",
        viewBox: "0 0 26 26",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("537F341D-C221-40B5-8A18-A90D6A06A7C2OVER")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-Layouts",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            opacity: "0.1976609",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Profile-EMPTY",
                transform: "translate(-260.000000, -565.000000)",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Intro-Block",
                    transform: "translate(220.000000, 298.000000)",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "insta",
                        transform: "translate(40.000000, 267.000000)",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          id: "Oval",
                          fill: "#000000",
                          cx: "13",
                          cy: "13",
                          r: "13",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M13.109589,10.260274 C14.5633212,10.260274 15.739726,11.4366788 15.739726,12.890411 C15.739726,14.3441431 14.5633212,15.5205479 13.109589,15.5205479 C11.6558569,15.5205479 10.4794521,14.3441431 10.4794521,12.890411 C10.4794521,11.4366788 11.6558569,10.260274 13.109589,10.260274 M13,8.94520548 C10.7577792,8.94520548 8.94520548,10.7622547 8.94520548,13 C8.94520548,15.2422208 10.7622547,17.0547945 13,17.0547945 C15.2422208,17.0547945 17.0547945,15.2377453 17.0547945,13 C17.0547945,10.7577792 15.2422208,8.94520548 13,8.94520548 M17.1643836,7.84931507 C16.6200569,7.84931507 16.1780822,8.29128974 16.1780822,8.83561644 C16.1780822,9.37994314 16.6200569,9.82191781 17.1643836,9.82191781 C17.7087103,9.82191781 18.1506849,9.37994314 18.1506849,8.83561644 C18.1506849,8.29128974 17.7087103,7.84931507 17.1643836,7.84931507 M12.391618,6.31506849 L13.109589,6.31506849 C15.2498698,6.31506849 15.5043406,6.32415673 16.349547,6.3605097 C17.1311357,6.39686266 17.553739,6.52864216 17.8400186,6.63770105 C18.2126364,6.78311291 18.4807396,6.95578949 18.762475,7.23752497 C19.0442105,7.51926044 19.2168871,7.78736356 19.3622989,8.15998144 C19.4713578,8.44171692 19.6031373,8.86886425 19.6394903,9.65045299 C19.6758433,10.4956594 19.6849315,10.7501302 19.6849315,12.890411 C19.6849315,15.0306917 19.6758433,15.2851625 19.6394903,16.1303689 C19.6031373,16.9119577 19.4713578,17.3345609 19.3622989,17.6208405 C19.2168871,17.9934584 19.0442105,18.2615615 18.762475,18.5432969 C18.4807396,18.8250324 18.2171806,18.997709 17.8400186,19.1431209 C17.5582831,19.2521798 17.1311357,19.3839593 16.349547,19.4203122 C15.5043406,19.4566652 15.2498698,19.4657534 13.109589,19.4657534 C10.9693083,19.4657534 10.7148375,19.4566652 9.86963107,19.4203122 C9.08804234,19.3839593 8.66543912,19.2521798 8.37915953,19.1431209 C8.00654164,18.997709 7.73843853,18.8250324 7.45670305,18.5432969 C7.17496758,18.2615615 7.00229099,17.9934584 6.85687914,17.6208405 C6.74782024,17.339105 6.61604075,16.9119577 6.57968778,16.1303689 C6.54333482,15.2851625 6.53424658,15.0306917 6.53424658,12.890411 C6.53424658,10.7501302 6.54333482,10.4956594 6.57968778,9.65045299 C6.61604075,8.86886425 6.74782024,8.44626104 6.85687914,8.15998144 C7.00229099,7.78736356 7.17496758,7.51926044 7.45670305,7.23752497 C7.73843853,6.95578949 8.00654164,6.78311291 8.37915953,6.63770105 C8.660895,6.52864216 9.08804234,6.39686266 9.86963107,6.3605097 C10.6103227,6.32415673 10.8966023,6.31506849 12.391618,6.31506849 M13,5 C10.8301246,5 10.5537939,5.00906002 9.70215176,5.04983012 C8.85050963,5.09060023 8.27066818,5.22197055 7.76330691,5.42129105 C7.23782559,5.62514156 6.78935447,5.89694224 6.34541336,6.34541336 C5.90147225,6.78935447 5.62967157,7.23782559 5.42129105,7.76330691 C5.22197055,8.27066818 5.08607022,8.85503964 5.04983012,9.70215176 C5.01359003,10.5537939 5,10.8255946 5,13 C5,15.1698754 5.00906002,15.4416761 5.04983012,16.2978482 C5.09060023,17.1494904 5.22197055,17.7293318 5.42129105,18.2366931 C5.62514156,18.7621744 5.89694224,19.2106455 6.34541336,19.6545866 C6.78935447,20.0985277 7.23782559,20.3748584 7.76330691,20.5787089 C8.27066818,20.7780294 8.85503964,20.9093998 9.70215176,20.9501699 C10.5537939,20.99094 10.8255946,21 13,21 C15.1698754,21 15.4416761,20.99094 16.2978482,20.9501699 C17.1494904,20.9093998 17.7293318,20.7780294 18.2412231,20.5787089 C18.7667044,20.3748584 19.2106455,20.0985277 19.6545866,19.6545866 C20.0985277,19.2106455 20.3703284,18.7621744 20.5787089,18.2366931 C20.7734994,17.7293318 20.9093998,17.1494904 20.9501699,16.2978482 C20.98641,15.4462061 21,15.1744054 21,13 C21,10.8301246 20.99094,10.5583239 20.9501699,9.70215176 C20.9093998,8.85050963 20.7734994,8.27066818 20.5787089,7.76330691 C20.3748584,7.23782559 20.0985277,6.78935447 19.6545866,6.34541336 C19.2106455,5.90147225 18.7667044,5.62967157 18.2366931,5.42129105 C17.7248018,5.22197055 17.1449604,5.09060023 16.2933182,5.04983012 C15.4416761,5.00906002 15.1698754,5 13,5",
                          id: "Fill-1",
                          fill: "#FFFFFF",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }